import API from 'services/api';

export interface IAtlasSession {
  automationId: number;
  sessionId: string;
  displayName: string;
}

export const getAtlasSessions = (): Promise<IAtlasSession[]> => {
  return API.get(`/api/atlas/sessions`).then(response => response?.data);
};
